import { isDateRangeEqual } from '@shared/utils/dateRange';
import { addSeconds, differenceInSeconds } from 'date-fns';
import type { DateRange } from './types';

export function limitDateRange(
  previousRange: DateRange,
  newRange: DateRange,
  max?: number | undefined
) {
  if (isInverted(newRange)) {
    return normalize(previousRange, max);
  }

  if (!isWithinLimit(newRange, max)) {
    return clampByChangedEndpoint(previousRange, newRange, max);
  }

  return newRange;
}

function clampByChangedEndpoint(
  previousRange: DateRange,
  newRange: DateRange,
  max?: number | undefined
) {
  if (!max) {
    return newRange;
  }

  const changed = {
    from: previousRange.from.getTime() !== newRange.from.getTime(),
    to: previousRange.to.getTime() !== newRange.to.getTime(),
  };
  const initial = isDateRangeEqual(previousRange, newRange);

  let { from, to } = newRange;
  if (changed.to) {
    from = addSeconds(newRange.to, -max);
  } else if (changed.from || initial) {
    to = addSeconds(newRange.from, max);
  }

  return { from, to };
}

function normalize(dateRange: DateRange, max?: number | undefined) {
  const ordered = order(dateRange);

  if (max && !isWithinLimit(ordered, max)) {
    return {
      from: ordered.from,
      to: addSeconds(ordered.from, max),
    };
  }

  return ordered;
}

function order(dateRange: DateRange): DateRange {
  return isInverted(dateRange)
    ? { from: dateRange.to, to: dateRange.from }
    : dateRange;
}

function isInverted(range: DateRange) {
  return range.to.getTime() < range.from.getTime();
}

function isWithinLimit(range: DateRange, max?: number | undefined) {
  return !max || differenceInSeconds(range.to, range.from) <= max;
}
